import React from "react";

import upIcon from "../../../assets/svg/up.svg";
import downIcon from "../../../assets/svg/down.svg";

import type { Order } from "../model";

type OrderHeaderProps = Pick<Order, "type" | "amount">;

export const OrderHeader: React.FC<OrderHeaderProps> = ({ type, amount }) => {
  const isBuy = type === "buy";

  return (
    <div className="order__header">
      <div className="order__type">
        <img
          className="icon"
          src={isBuy ? upIcon : downIcon}
          alt="Order type icon"
        />
        <span className="text">{isBuy ? "Up" : "Down"}</span>
      </div>
      <div className="order__amount">
        <span className="amount">{amount}</span>
        <span className="unit"> $</span>
      </div>
    </div>
  );
};
